<template>

	<header class="page-header page-header--hero" v-sticky="{ fixedClass: 'page-header--fixed' }" @click="scrollToContent()">

		<div class="page-header__nav">
			<img class="page-header--hero__logo" alt="GoodHoodMusic" src="../assets/img/good-hood-music.svg">
		</div>

		<noscript is="lazy-element" class="lazy-element ratio-square">
			<video class="page-header--hero__video" autoplay="autoplay" muted="muted" loop="loop" :src="video"/>
		</noscript>

	</header>

</template>

<script>
	import Sticky from '../directives/sticky.js';
	import LazyElement from '../components/LazyElement.vue';

	export default {
		name: 'PageHeaderHero',
		directives: {
			Sticky
		},
		components: {
			LazyElement
		},
		props: ['video'],
		data() {
			return {
			}
		},
		methods: {
			scrollToContent() {
				document.querySelector('#page-anchor').scrollIntoView({behavior:'smooth'});
			}
		}
	}
</script>

<style>
</style>
